import React from 'react';
import { useSelector } from 'react-redux';

import PneumoniaImage from '../../assets/images/death_reasons/pneumoniaImage';
import PneumoniaEng from '../../assets/images/death_reasons/pneumoniaEng';
import PneumoniaRus from '../../assets/images/death_reasons/pneumoniaRus';
import Border from '../../assets/images/border';

import './pneumonia.scss';

const Pneumonia = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='pneumonia'>
            <Border />
            {language === 'ENG' ? <PneumoniaEng /> : <PneumoniaRus />}
            <PneumoniaImage />
            <span className='pneumonia-text'>
                {language === 'RUS' ? 'Пневмония ежегодно уносит жизни около 2,5 миллионов человек. Риск заболевания сохраняется даже при здоровом образе жизни, особенно в периоды сезонных эпидемий. Не забывайте о вакцинации и обязательно своевременно лечитесь.' : 'Pneumonia claims approximately 2.5 million lives annually. The risk of contracting the disease persists even with a healthy lifestyle, especially during seasonal epidemics. Vaccination and timely treatment help prevent severe outcomes.'}
            </span>
        </div>
    );
};

export default Pneumonia;